import React, { useState, useEffect } from "react";
import "./Codeworkflow.css";
import CodingIcon from "../../common/assets/images/coding.png";
import CDQSReviewIcon from "../../common/assets/images/cdqs_review.png";
import OutstandingTasksIcon from "../../common/assets/images/outstanding_tasks.png";
import AuditsIcon from "../../common/assets/images/audits.png";
import UncodedEpisodesIcon from "../../common/assets/images/uncoded_episodes.png";
import EpisodesCodedToday from "../../common/assets/images/episodes_coded_today.png";
import outstandingCodingIcon from "../../common/assets/images/outstanding_coding.png";
import errorDrgsIcon from "../../common/assets/images/error_drgs.png";
import hospitalAcquiredComplicationsIcon from "../../common/assets/images/hospital_acquired_complications.png";
import abf_nwauOptimisationIcon from "../../common/assets/images/abf_nwau_optimisation.png";
import outliersIcon from "../../common/assets/images/outliers.png";
import auditResultsIcon from "../../common/assets/images/audit_results.png";
import codingErrorsIcon from "../../common/assets/images/coding_errors.png";
import clinicalDocumentationQueriesIcon from "../../common/assets/images/clinical_documentation_queries.png";
import codingKpisIcon from "../../common/assets/images/coding_kpis.png";
import performanceIcon from "../../common/assets/images/performance.png";
import { Accordion, Row, Col, Placeholder } from "react-bootstrap";
import Coding from "./Coding/Coding";
import { navigationTree } from "../../components/Sidebar/Service";
import Audits from "./HealthInsuranceManager/HealthInformationManager";
import { useSelector, useDispatch } from "react-redux";
import {
  getWorkflowsCountData,
  getUnassignedCount,
  // getForAuditedCount,
} from "./CodeworkflowSlicer";
import {
  setAutoApplyUnassigned,
  setWorkspaceRole,
  resetHimFilters,
} from "./HealthInsuranceManager/redux/HealthInformationManagerSlicer";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography } from "@mui/material";
import { toast } from "react-toastify";

const Codeworkflow = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { codesCountsLoading, codesCountsData, codesCountsError } = useSelector(
    (state) => state.codeWorkflow.workflowCount,
  );
  const {codingAllocationCount} = useSelector(
    (state) => state.codeWorkflow,
  );
  console.log(codingAllocationCount,"codingAllocationCount")
  const [reportingAccordion, setReportingAccordion] = useState(null);
  const [codingPage, setCodingPage] = useState(false);
  const [auditPage, setAuditPage] = useState(false);
  const [navData, setNavData] = useState([]);
  const [eventKey, setEventKey] = useState(null);
  const [codeworkflowPage, setCodeworkflowPage] = useState(true);
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;
  const codebooksanprodEnv = process.env.REACT_APP_FLAG_SAN_PROD;
  const codebooksanEnv = process.env.REACT_APP_FLAG_SAN;
  const isSanEnvironment = codebooksanEnv || codebooksanprodEnv;
  const WorkQueueOptions = Object.keys(
    codesCountsData?.my_work_queue || {},
  ).map((item) => ({
    name: item,
    icon:
      item === "Coding"
        ? CodingIcon
        : item === "Audits"
          ? AuditsIcon
          : item === "CDQs for Review"
            ? CDQSReviewIcon
            : item === "Outstanding Tasks"
              ? OutstandingTasksIcon
              : CodingIcon,
    path: item === "Coding" ? "Coder-Workspace" : "",
    tasks: codesCountsData.my_work_queue[item],
  }));

  const codingAllocationOptions = [
    {
      codingName: "Coding Allocation",
      unassignedEpisodes: "Unassigned Episodes",
      path: "HIM-Workspace",
      noOfUnassignedEpisodes: codingAllocationCount.unassigned ?? 0,
    },
    {
      codingName: "Audit Allocation",
      unassignedEpisodes: "For Audit",
      path: "HIM-Workspace",
      noOfUnassignedEpisodes: codingAllocationCount.forAudited ?? 0,
    },
  ];

  const snapshotOptions = Object?.keys(codesCountsData?.snapshot || {})?.map(
    (item) => ({
      snapshotName: item,
      icon:
        item === "Uncoded Episodes"
          ? UncodedEpisodesIcon
          : item === "Episodes Coded Today"
            ? EpisodesCodedToday
            : item === "Episodes Audited Today"
              ? AuditsIcon
              : UncodedEpisodesIcon,
      snapshotCount: codesCountsData?.snapshot[item],
    }),
  );

  const auditingData = [
    {
      headingName: codebookusaEnv
        ? "ABF and Weight Optimisation"
        : "ABF and NWAU Optimisation",
      key: "1",
      body: "For the month of May 2025, 6750 episodes have been coded at a first pass accuracy rate of 93%. The system identified 250 episodes requiring review, resulting in a confirmed DRG change rate of 25%. This review process generated an increase of 55 NWAU, representing additional ABF revenue of $355,575.",
    },
    {
      headingName: codebookusaEnv
        ? "ICD-10-CM,PCS and CPT"
        : "ICD-10-AM and ACHI",
      key: "2",
      body: "During May 2025, audits were conducted on 820 inpatient records focusing on ICD-10-AM and ACHI coding accuracy. 145 records (17.7%) showed coding discrepancies, predominantly due to incorrect sequencing and omissions. Corrections resulted in an additional 35 NWAU and recaptured revenue of approximately $226,000.",
    },
    {
      headingName: "Coding Quality Assurance",
      key: "3",
      body: "In May 2025, the Coding Quality Assurance audit reviewed 1,200 randomly selected records. A total of 180 coding errors were identified, mainly involving secondary diagnosis misclassification. Targeted coder training sessions addressing these specific errors have since improved overall accuracy rates by 6% in subsequent audits.",
    },
    {
      headingName: "DRGs, Error DRGs",
      key: "4",
      body: "The May 2025 DRG audit analyzed 940 episodes, identifying 110 DRG assignment errors primarily due to incomplete documentation of complications and comorbidities. Post-review corrections adjusted DRGs in 30% of the cases, leading to a revenue adjustment and an NWAU increase worth approximately $312,500.",
    },
    {
      headingName: "Clinical Speciality",
      key: "5",
      body: "In May 2025, clinical specialty-specific audits focused on cardiology and orthopaedics reviewed 600 episodes. Key findings included under-coding of complex cardiac procedures and missing orthopaedic intervention codes, resulting in corrected documentation that increased NWAU by 48 units, translating into additional funding of $310,560.",
    },
    {
      headingName: "My Audits",
      key: "6",
      body: "During May 2025, individual coder audits were performed on 250 records, identifying personalized improvement areas for each coder. On average, each coder received tailored feedback on 8 coding errors, focusing on documentation clarity and procedure code accuracy. Subsequent follow-up audits revealed an average accuracy improvement of 7.5% per coder.",
    },
  ];

const reportingsOptions = isSanEnvironment
  ? [
      {
        reportName: "Outstanding Coding",
        reportIcon: outstandingCodingIcon,
        path: "/outstanding-report",
      },
      {
        reportName: "Error DRGs",
        reportIcon: errorDrgsIcon,
        path: "/error-drg-report",
      },
      {
        reportName: "Hospital Acquired Complications (HACs)",
        reportIcon: hospitalAcquiredComplicationsIcon,
        path: "/hac-report",
      },
      {
        reportName: "DRG Outliers",
        reportIcon: outliersIcon,
        path: "/drg-outlier-report",
      },
    ]
  : [
      {
        reportName: "Outstanding Coding",
        reportIcon: outstandingCodingIcon,
        path: "/outstanding-report",
      },
      {
        reportName: "Error DRGs",
        reportIcon: errorDrgsIcon,
        path: "/error-drg-report",
      },
      {
        reportName: codebookusaEnv
          ? "ABF and Weight Optimisation"
          : "ABF and NWAU Optimisation",
        reportIcon: abf_nwauOptimisationIcon,
      },
      {
        reportName: "Hospital Acquired Complications (HACs)",
        reportIcon: hospitalAcquiredComplicationsIcon,
        path: "/hac-report",
      },
      {
        reportName: "DRG Outliers",
        reportIcon: outliersIcon,
        path: "/drg-outlier-report",
      },
      {
        reportName: "Audit Results",
        reportIcon: auditResultsIcon,
      },
      {
        reportName: "Coding Errors and Edits",
        reportIcon: codingErrorsIcon,
      },
      {
        reportName: "Clinical Documentation Queries (CDQs)",
        reportIcon: clinicalDocumentationQueriesIcon,
      },
      {
        reportName: "Coding KPIs",
        reportIcon: codingKpisIcon,
      },
      {
        reportName: "Performance",
        reportIcon: performanceIcon,
      },
    ];

  const codeworkHandleRouterPage = (itemQueue) => {
    if (itemQueue?.name === "Coding") {
      navigate(`/${itemQueue?.path}`);
    }
    //   setAuditPage(true);
    //   setCodingPage(false);
    //   setCodeworkflowPage(false);
    // }else if(itemQueue === "Audits"){
    //   setCodingPage(false);
    //   setAuditPage(true);
    //   setCodeworkflowPage(false);
    // }
    // else{
    //   setCodeworkflowPage(true);
    //   setAuditPage(false);
    //   setCodingPage(false);
    // }
  };

  const toggleAccordion = (id) => {
    setEventKey(id === eventKey ? null : id);
  };
  useEffect(() => {
    dispatch(getWorkflowsCountData());
    dispatch(getUnassignedCount());
    // dispatch(getForAuditedCount());
    navigationTree().then((data) => {
      setNavData(data);
    });
  }, []);

  // useEffect(() => {
  //   if (unassigned.error) {
  //     toast.error("Failed to load Unassigned count");
  //   }
  // }, [unassigned.error]);

  // useEffect(() => {
  //   if (forAudited.error) {
  //     toast.error("Failed to load For Audit count");
  //   }
  // }, [forAudited.error]);

  return (
    <Box sx={{ height: "inherit" }}>
      <Box className="codework-flow-container">
        {codeworkflowPage ? (
          <Grid
            container
            columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            spacing={1}
            sx={{ width: "100%" }}
          >
            <Grid
              sx={{
                width: {
                  lg: "20%",
                  md: "100%",
                  sm: "100%",
                  xs: "100%",
                },
              }}
              className="codework-flow-work-queue-messages-container"
            >
              <Box className="work-queue-container">
                <div className="my-work-queue-section">
                  <Typography
                    sx={{
                      fontSize: {
                        lg: "14px",
                        md: "13px",
                        sm: "12px",
                        xs: "12px",
                      },
                      fontWeight: "bold",
                    }}
                    className="my-work-queue-heading"
                  >
                    My Work Queue
                  </Typography>
                  <Box
                    sx={{
                      display: {
                        lg: "block",
                        md: "flex",
                        sm: "flex",
                        xs: "flex",
                      },
                      justifyContent: {
                        md: "center",
                        sm: "center",
                        xs: "center",
                      },
                      flexWrap: "wrap",
                      width: "100%",
                    }}
                  >
                    {codesCountsLoading ? (
                      <Box>
                        <Placeholder animation="glow">
                          <Placeholder xs={12} className="queuePlaceholder" />
                        </Placeholder>
                      </Box>
                    ) : codesCountsError ? (
                      <div className="work-queue-container-error">
                        <Typography>No data found</Typography>
                      </div>
                    ) : (
                      WorkQueueOptions.map((itemQueue) => (
                        <Box
                          key={itemQueue.name}
                          className="my-work-queue-cards"
                          sx={{
                            width: {
                              lg: "100%",
                              md: "46%",
                              sm: "46%",
                              xs: "46%",
                            },
                            m: {
                              lg: 0,
                              md: 1,
                              sm: 1,
                              xs: 1,
                            },
                          }}
                          onClick={() => codeworkHandleRouterPage(itemQueue)}
                        >
                          <div className="my-work-queue-cards-top">
                            <Typography
                              variant="body"
                              sx={{
                                fontSize: {
                                  lg: "14px",
                                  md: "13px",
                                  sm: "12px",
                                  xs: "12px",
                                },
                              }}
                              className="my-work-queue-card-name"
                            >
                              {itemQueue?.name}
                            </Typography>
                            <div className="my-work-queue-card-icon">
                              <img
                                src={itemQueue?.icon}
                                alt={itemQueue?.name}
                              />
                            </div>
                          </div>
                          <Typography
                            variant="body1"
                            sx={{
                              fontSize: {
                                lg: "14px",
                                md: "13px",
                                sm: "12px",
                                xs: "12px",
                              },
                            }}
                            className="my-work-queue-card-tasks"
                          >
                            {itemQueue?.tasks} tasks
                          </Typography>
                        </Box>
                      ))
                    )}
                  </Box>
                </div>
              </Box>
              <div className="messages-container">
                <div className="messages-section">
                  <Typography
                    className="messages-heading"
                    sx={{
                      fontSize: {
                        lg: "14px",
                        md: "13px",
                        sm: "12px",
                        xs: "12px",
                      },
                      fontWeight: "bold",
                    }}
                  >
                    Messages
                  </Typography>
                  <Typography
                    className="no-messages"
                    sx={{
                      fontSize: {
                        lg: "14px",
                        md: "13px",
                        sm: "12px",
                        xs: "12px",
                      },
                    }}
                  >
                    No messages
                  </Typography>
                </div>
              </div>
            </Grid>
            <Grid
              sx={{
                width: {
                  lg: "53%",
                  md: "100%",
                  sm: "100%",
                  xs: "100%",
                },
              }}
              className="codework-flow-allocation-container"
            >
              <div className="task-allocation-section">
                <Typography
                  variant="body"
                  sx={{
                    fontSize: {
                      lg: "14px",
                      md: "13px",
                      sm: "12px",
                      xs: "12px",
                    },
                  }}
                  className="task-allocation-heading"
                >
                  Task Allocation
                </Typography>
                <Box
                  sx={{
                    display: {
                      lg: "block",
                      md: "flex",
                      sm: "flex",
                      xs: "flex",
                    },
                    justifyContent: {
                      lg: "start",
                      md: "space-between",
                      sm: "space-between",
                      xs: "start",
                    },
                    flexWrap: "wrap",
                    width: "100%",
                  }}
                >
                  {codingAllocationOptions.map((codingItem) => (
                    <Box
                      key={codingItem.codingName}
                      onClick={() => {
                        let role;
                        if (codingItem.codingName === "Coding Allocation") {
                          role = "coder";
                        } else {
                          role = "auditor";
                        }
                        sessionStorage.setItem("workspaceRole", role);
                        dispatch(setWorkspaceRole(role));
                        dispatch(resetHimFilters());
                        navigate(`/${codingItem?.path}`);
                      }}
                      sx={{
                        display: {
                          lg: "block",
                          md: "flex",
                          sm: "flex",
                          xs: "flex",
                        },
                        flexDirection: {
                          md: "column",
                          sm: "column",
                          xs: "column",
                        },
                        alignItems: { md: "start", sm: "start", xs: "start" },
                        justifyContent: {
                          md: "start",
                          sm: "start",
                          xs: "start",
                        },
                        mr: { sm: 1, xs: 1 },
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            lg: "14px",
                            md: "13px",
                            sm: "12px",
                            xs: "12px",
                          },
                          my: 1,
                        }}
                        className="coding-name-heading"
                      >
                        {codingItem.codingName}
                      </Typography>
                      <div className="coding-allocation-section">
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "13px",
                              sm: "12px",
                              xs: "12px",
                            },
                          }}
                          className="unassigned-episodes"
                          onClick={() => {
                            dispatch(setAutoApplyUnassigned(true));
                            navigate(`/${codingItem?.path}`);
                          }}
                        >
                          {codingItem.unassignedEpisodes}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: {
                              lg: "14px",
                              md: "13px",
                              sm: "12px",
                              xs: "12px",
                            },
                          }}
                          className="no-of-unassigned-episodes"
                        >
                          {codingItem.noOfUnassignedEpisodes}
                        </Typography>
                      </div>
                    </Box>
                  ))}
                </Box>
              </div>
              <div className="snapshot-section">
                <Typography
                  sx={{
                    fontSize: {
                      lg: "14px",
                      md: "13px",
                      sm: "12px",
                      xs: "12px",
                    },
                    fontWeight: "600",
                  }}
                  className="snapshot-heading"
                >
                  Snapshot
                </Typography>
                {codesCountsLoading ? (
                  <Box className="snapshot-loader">
                    <Placeholder animation="glow">
                      <Placeholder xs={12} className="queuePlaceholder" />
                    </Placeholder>
                  </Box>
                ) : (
                  <Box
                    className="snapshot-grid"
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        lg: "repeat(3, 1fr)",
                        md: "repeat(3, 1fr)",
                        sm: "repeat(2, 1fr)",
                        xs: "repeat(2, 1fr)",
                      },
                      gap: "10px",
                    }}
                  >
                    {snapshotOptions.map((snapshotItem) => (
                      <Box
                        key={snapshotItem.snapshotName}
                        className="snapshot-cards"
                      >
                        <div className="snapshot-cards-top">
                          <Typography
                            className="snapshot-name"
                            sx={{ fontSize: "13px" }}
                          >
                            {snapshotItem.snapshotName}
                          </Typography>
                          <span className="snapshot-icon">
                            <img
                              src={snapshotItem.icon}
                              alt={snapshotItem.snapshotName}
                            />
                          </span>
                        </div>

                        <Typography
                          className="snapshot-count"
                          sx={{ fontSize: "15px" }}
                        >
                          {snapshotItem.snapshotCount}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                )}
              </div>
              {!isSanEnvironment && (
                <div className="auditing-section">
                  <Typography
                    className="auditing-heading"
                    variant="body"
                    sx={{
                      fontSize: {
                      lg: "14px",
                      md: "13px",
                      sm: "12px",
                      xs: "12px",
                    },
                  }}
                >
                  Auditing
                </Typography>
                {auditingData.map((auditingItem) => (
                  <Accordion
                    activeKey={eventKey}
                    className="auditing-accordion-section"
                    key={auditingItem.key}
                  >
                    <Accordion.Item
                      eventKey={auditingItem.key}
                      className="auditing-accordionItem-section"
                      onClick={() => toggleAccordion(auditingItem.key)}
                    >
                      <Accordion.Header className="auditing-accordionHeader-section">
                        {auditingItem.headingName}
                      </Accordion.Header>
                      <Accordion.Body className="auditing-accordionBody-section">
                        {auditingItem.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                ))}
              </div>)}
            </Grid>
            <Grid
              sx={{
                width: {
                  lg: "25%",
                  md: "100%",
                  sm: "100%",
                  xs: "100%",
                },
              }}
              className="reporting-container"
            >
              <div className="reporting-heading-section">
                <Typography
                  sx={{
                    fontSize: {
                      lg: "14px",
                      md: "13px",
                      sm: "12px",
                      xs: "12px",
                    },
                    fontWeight: "bold",
                  }}
                  className="reporting-heading"
                >
                  Reporting
                </Typography>
                {/* <Typography
                  sx={{
                    fontSize: {
                      lg: "14px",
                      md: "13px",
                      sm: "12px",
                      xs: "12px",
                    },
                  }}f
                  className="reporting-side-heading"
                >
                  My Reports
                </Typography> */}
              </div>
              <Box
                className="reporting-cards"
                sx={{
                  display: {
                    lg: "block",
                    md: "flex",
                    sm: "flex",
                    xs: "flex",
                  },
                  justifyContent: {
                    md: "space between",
                    sm: "space between",
                    xs: "space between",
                  },
                  flexWrap: "wrap",
                  width: "100%",
                }}
              >
                {reportingsOptions.map((reportItem) => (
                  <Box
                    key={reportItem.reportName}
                    className="reporting-cards-section"
                    sx={{
                      width: {
                        lg: "100%",
                        md: "46%",
                        sm: "46%",
                        xs: "46%",
                      },
                      m: {
                        lg: 0,
                        md: 1,
                        sm: 1,
                        xs: 1,
                      },
                    }}
                    onClick={() => navigate(reportItem.path)}
                  >
                    <Typography
                      sx={{
                        fontSize: {
                          lg: "14px",
                          md: "13px",
                          sm: "12px",
                          xs: "12px",
                        },
                        fontWeight: "500",
                      }}
                      className="reporting-cards-name"
                    >
                      {reportItem.reportName}
                    </Typography>
                    <span className="reporting-cards-icon">
                      <img
                        src={reportItem?.reportIcon}
                        alt={reportItem.reportName}
                      />
                    </span>
                  </Box>
                ))}
              </Box>
            </Grid>
          </Grid>
        ) : codingPage ? (
          <Coding />
        ) : (
          <Audits setCodeworkflowPage={setCodeworkflowPage} />
        )}
      </Box>
    </Box>
  );
};

export default Codeworkflow;